import {api} from './api'

export interface IBookingSlotResponse {
  booking_slot: IBookingSlot
}

export interface IBookingSlot {
  id: string
  location_id: string
  class_id: string
  customer_id: string
  order_line_item_id: string
  date_start: string
  date_end: string
  status: string
  created_at: string
  updated_at: string
  customer: IBookingCustomer
  location: IBookingLocation
  order_line_items: IBookingLineItems
  order: IBookingOrder
  class: IBookingClass
  note: string
}

export interface IBookingCustomer {
  id: string
  name: string
  email: string
  phone: string
  shopify_customer_id: string
  address_1: string
  address_2: string
  city: string
  state: string
  zip_code: string
  country: string
  created_at: string
  updated_at: string
}

export interface IBookingLocation {
  id: string
  shopify_location_id?: string
  name: string
  address_1: string
  address_2: string
  city: string
  state: string
  zip_code: string
  country: string
  timezone: string
  capacity: string
  created_at: string
  updated_at: string
}

export interface IBookingLineItems {
  id: string
  order_id: string
  name: string
  price: number
  quantity: number
  location_id: string
  created_at: string
  updated_at: string
}

export interface IBookingOrder {
  id: string
  order_number: string
  order_date: string
  currency: string
  total_price: number
  total_discount: number
  source_order_id: string
  order_id: string
  created_at: string
  updated_at: string,
  email_24_hr: number,
  sms_24_hr: number
}

export interface IBookingClass {
  id: string
  name: string
  shopify_variant_id: string
  time_zone: string
  additional_information_fields?: []
  created_at: string
  updated_at: string
}

export const bookingSlotsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getBookingSlot: build.query<IBookingSlotResponse, string>({
      query: (bookingId) => {
        return { url: `/booking_slots/${bookingId}`, method: 'GET' }
      },
      keepUnusedDataFor: 0,
      forceRefetch: ({ currentArg, previousArg }) => {
        return currentArg !== previousArg
      }
    }),
    updateBookingSlotSingle: build.mutation<any,any>({
      query: ({ bookingId, body}) => ({
        url: `/booking_slots/${bookingId}`,
        method: 'PUT',
        body
      })
    }),
  })
})

export const {
  useGetBookingSlotQuery,
  useUpdateBookingSlotSingleMutation
} = bookingSlotsApi
